/***************************************************
Alexander Self
7/29/17
Profile reducer: Handles all viewing, creating and editing of employees
****************************************************/
import { FETCH_LEVEL_EMPLOYEES, UNAUTH_USER, FETCH_EMPLOYEE_TO_EDIT,
  SUBMIT_EDIT_PROFILE, CREATE_EMPLOYEE_PROFILE, FETCH_EMPLOYEE_PROFILE,
  CREATE_LOGIN_PROFILE, SUBMIT_EDIT_LOGIN
} from '../actions/types';
const initState = {
  employees: [],
  view: {
    selectedEmployee: {
      manager: {},
      managedEmployees: [],
      stats: {
        harvest: {
          harvestHours: [],
          harvestHourTotal: 0
        },
        equipment: {
          equipmentHours: [],
          equipmentHourTotal: 0
        },
        costCenter: {
          costCenterHours: [],
          costCenterHourTotal: 0
        }
      }
    },
    schedule: [],
    timesheets: []
  },
  create: {},
  edit: {
    employee: {}
  }
};

export default function ProfileReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_LEVEL_EMPLOYEES:
      return { ...state, employees: action.payload };
    case FETCH_EMPLOYEE_TO_EDIT:
      return { ...state, edit: {
        employee: action.payload
      } };
    case SUBMIT_EDIT_PROFILE:
      return { ...state, employees: action.payload,
        edit: { employee: {} }
      };
    case CREATE_EMPLOYEE_PROFILE:
      return { ...state,
        employees: action.payload
      };
    case FETCH_EMPLOYEE_PROFILE:
      return { ...state,
        view: {
          selectedEmployee: {
            ...action.payload.employee,
            manager: action.payload.manager,
            managedEmployees: action.payload.managedEmployees,
            stats: action.payload.stats
          }
        }
      };
    case CREATE_LOGIN_PROFILE:
      return state;
    case SUBMIT_EDIT_LOGIN:
      return state;
    case UNAUTH_USER:
      return initState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profile_reducer.js